import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// Import useTheme module for its side-effect: reads localStorage and applies
// the theme to <html> synchronously before React's first render → no flash
// of wrong theme.
import '@/hooks/useTheme';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
